import { Component, OnInit } from '@angular/core';
import { ElectronicSharing } from '../../Models/electronic-sharing';
import { DomSanitizer } from '@angular/platform-browser';
import { ElectronicSharingService } from '../../services/electronic-sharing.service';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';

@Component({
  selector: 'get-electronic-sharing-details',
  templateUrl: './get-electronic-sharing-details.component.html',
  styleUrls: ['./get-electronic-sharing-details.component.scss']
})
export class GetElectronicSharingDetailsComponent implements OnInit {
 model = {} as ElectronicSharing;
  constructor(private route: Router,
      private diag: NbDialogRef<GetElectronicSharingDetailsComponent>,
      public sanitizer: DomSanitizer,
      private service: ElectronicSharingService) { }

 ngOnInit() {
       this.route.events.subscribe(()=>{
       this.diag.close('false');
      });
   }
   getLabelData(text) {
     return this.sanitizer.bypassSecurityTrustHtml(text);
   }
 
   close() {
     this.diag.close();
   }
 
   downloadFile(fileName) {
     this.service.downloadFile(fileName).subscribe((blob) => {
           downloadFileUtil(blob, fileName);
         });
   }
 

}
